import { GlBadge, GlTooltipDirective, GlIcon } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { confidentialityInfoText } from '../constants';
export default {
    name: 'ConfidentialityBadge',
    components: {
        GlBadge,
        GlIcon
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        workspaceType: {
            type: String,
            required: true
        },
        issuableType: {
            type: String,
            required: true
        },
        hideTextInSmallScreens: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        confidentialTooltip () {
            return confidentialityInfoText(this.workspaceType, this.issuableType);
        },
        confidentialTextClass () {
            return {
                'gl-sr-only @sm/panel:gl-not-sr-only': this.hideTextInSmallScreens,
                '!gl-ml-2': true
            };
        }
    }
};
